import 'lazysizes';
import throttle from 'lodash/throttle';
import { H } from '../highway';
import { navigation } from './navigation';
import { mq } from '../util/matchMedia';
import {
  unifyTouchEvents,
  getAllPages,
  getCurrentSlug,
  getIndexBySlug,
  setGlobalState,
  readGlobalState,
} from '../util/helpers';

const state = {
  throttle: 400,
  threshold: 10,
  fromIndex: null,
  toIndex: null,
  pages: null,
  pageCount: null,
  currentPage: null,
  y0: null,
};

export const scrollNavigation = (() => {

  const init = () => {
    initialiseState();
    navigation.init();

    if (mq.isDesktop) {
      addWheelEventListener();
      addTouchEventListeners();
    }
  }

  // Store data about current page, total # of pages etc
  const initialiseState = () => {
    state.pages = getAllPages();
    state.pageCount = state.pages.length;
    state.currentPage = getCurrentSlug();
    state.fromIndex = getIndexBySlug(state.currentPage);
    setGlobalState('isTransitioning', false);
  }


  // Wheel event listeners
  const addWheelEventListener = () => {
    window.addEventListener('wheel', onScrollThrottled);
  }

  const removeWheelEventListener = () => {
    window.removeEventListener('wheel', onScrollThrottled);
  }

  const onScroll = (e) => {
    if (readGlobalState('isTransitioning')) return;
    state.currentPage = getCurrentSlug();
    state.fromIndex = getIndexBySlug(state.currentPage);

    const direction = Math.sign(e.deltaY);
    const velocity = Math.abs(e.deltaY);

    // Ignore tiny scrolls, as likely accidental
    if (velocity < state.threshold) return;

    direction < 0 ? showPreviousPage() : showNextPage();
  }

  const onScrollThrottled = throttle(onScroll, state.throttle);

  // Mobile swipe / touch events
  const addTouchEventListeners = () => {
    window.addEventListener('touchstart', saveTouchStartPosition);
    window.addEventListener('touchend', processTouchScrollEvent);
  }

  const removeTouchEventListeners = () => {
    window.removeEventListener('touchstart', saveTouchStartPosition);
    window.removeEventListener('touchend', processTouchScrollEvent);
  }

  const saveTouchStartPosition = (e) => {
    state.y0 = unifyTouchEvents(e).clientY;
  }

  const processTouchScrollEvent = (e) => {
    if (readGlobalState('isTransitioning')) return;
    state.currentPage = getCurrentSlug();
    state.fromIndex = getIndexBySlug(state.currentPage);
    const y1 = unifyTouchEvents(e).clientY;
    if (y1 === state.y0) return;

    const velocity = Math.abs(state.y0 - y1);
    if (velocity < 10) return;

    y1 < state.y0 ? showNextPage() : showPreviousPage();
  }

  // Transition between pages
  const showNextPage = () => {
    // If we're on the last page, reset to 0
    // Else redirect to the next page's URL
    state.toIndex = isLastPage() ? 0 : state.fromIndex + 1;
    const toPageUrl = state.pages[state.toIndex].url;
    setGlobalState('isTransitioning', true);
    H.redirect(toPageUrl);

    state.fromIndex = state.toIndex;
  }

  const showPreviousPage = () => {
    // If we're on the first page, exit
    if (state.fromIndex <= 0) return;

    // Redirect to the previous page's URL
    state.toIndex = state.fromIndex - 1;
    const toPageUrl = state.pages[state.toIndex].url;
    setGlobalState('isTransitioning', true);
    H.redirect(toPageUrl);

    state.fromIndex = state.toIndex;
  }

  const isLastPage = () => {
    return state.fromIndex === state.pageCount - 1;
  }

  return {
    init,
    addTouchEventListeners,
    removeTouchEventListeners,
    removeWheelEventListener,
    addWheelEventListener,
  }

})();